import { axiosMain } from '@/utils/axios/configs'

export default function (config) {
  return axiosMain(config)
}